export const environment = {
    ENV_NAME: 'development',
    API_URL: 'https://dev-api.onsceneservices.com'
};
